<ps-ui-modal class="template-modal">
  <h2 psUiModalTitle class="title">Save as Template</h2>
  <ps-ui-modal-body class="template-list-body">
    <form [formGroup]="form">
      <div class="form">
        <div class="form-group">
          <label>Template Folder</label>

          <ps-ui-tree-dropdown
            [label]="
              selectedFolder && selectedFolder.name ? selectedFolder.name : ''
            "
            labelAlignment="start"
            labelNone="Select Template Folder"
            [isRemoveSelection]="!!selectedFolder?.id"
            [dropdownItems]="templateList"
            [maxDepth]="MAX_NAVIGATION_DEPTH"
            [folderOption]="templateFolderOption"
            [addNewFolder]="showCreateFolderButton"
            footerInputPlaceholder="New Folder"
            footerButtonText="New Folder"
            formControlName="selectedFolder"
            (selectFolder)="selectFolder($event)"
            (selectFile)="selectFolder($event)"
            (saveFolderName)="createNewFolder($event)"
            (removeSelection)="unsetSelectedFolder()"
            psUiGtagEvent
            trackOn="change"
            action="template"
            category="Tools"
            [params]="{ event_label: 'Template Selected/Removed' }"
          ></ps-ui-tree-dropdown>
        </div>
        <div class="form-group">
          <label>Template Name</label>
          <ps-ui-select-dropdown
            [dropdownItems]="templates"
            [field]="'name'"
            [mcIconIdentifier]="'is_mc_template'"
            [icon]="true"
            [iconClass]="'fa fa-file-text-o'"
            [clearSearch]="false"
            class="uppercase"
            [newTextInput]="true"
            [newTextSelectionType]="'button'"
            [newTextInputPlaceHolder]="'New Template'"
            [noItemMessage]="'No Template created yet'"
            [newInputLabel]="'New Template'"
            labelNone="Select Template Name"
            labelAlignment="start"
            [loading]="false"
            formControlName="templateName"
            (selectedItem)="selectTemplate($event)"
            (selectedFooterItem)="createNewTemplate($event)"
            [disabled]="!selectedFolder?.id"
            [label]="this.selectedTemplate?.name"
          >
          </ps-ui-select-dropdown>
        </div>
        <div class="form-group mb-0">
          <label>Options</label>
        </div>
      </div>
      <div class="option-form">
        <div class="row text-center">
          <div class="col-md-12">
            <ps-ui-slider
              [selected]="form.value.is_suppliers_list"
              (selectedChange)="patchFormValue('is_suppliers_list', $event)"
            >
            </ps-ui-slider>
            <span class="selectBtn select-btn-on-list">
              Save Supplier's list and allocation</span
            >
          </div>
          <div class="col-md-12 my-2" *ngIf="isMultiCountrySurvey">
            <ps-ui-slider
              [selected]="form.value.is_mc_template"
              (selectedChange)="patchFormValue('is_mc_template', $event)"
            >
            </ps-ui-slider>
            <span class="selectBtn select-btn-on-list"
              >Save a Multi-Country Template</span
            >
          </div>
        </div>
      </div>
    </form>
  </ps-ui-modal-body>
  <ps-ui-modal-footer>
    <button
      type="button"
      psUiButton
      color="secondary"
      class="btn btn-default cancelBtn"
      (click)="close()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-default clearBtn"
      psUiButton
      [disabled]="!selectedFolder || !selectedTemplate"
      (click)="save()"
    >
      {{ selectedTemplate?.id ? 'Update Template' : 'Save Template' }}
    </button>
  </ps-ui-modal-footer>
</ps-ui-modal>
